import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ClockFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22ZM13.25 7C13.25 6.66848 13.1183 6.35054 12.8839 6.11612C12.6495 5.8817 12.3315 5.75 12 5.75C11.6685 5.75 11.3505 5.8817 11.1161 6.11612C10.8817 6.35054 10.75 6.66848 10.75 7V12C10.7501 12.3315 10.8818 12.6494 11.1163 12.8837L14.6513 16.42C14.7674 16.5361 14.9053 16.6283 15.057 16.6911C15.2087 16.754 15.3714 16.7863 15.5356 16.7863C15.6999 16.7863 15.8625 16.754 16.0142 16.6911C16.166 16.6283 16.3039 16.5361 16.42 16.42C16.5361 16.3039 16.6283 16.166 16.6911 16.0142C16.754 15.8625 16.7863 15.6999 16.7863 15.5356C16.7863 15.3714 16.754 15.2087 16.6911 15.057C16.6283 14.9053 16.5361 14.7674 16.42 14.6513L13.25 11.4825V7Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ClockFilledIcon.displayName = 'ClockFilledIcon';
